<template>
    <form class="o-search__venezia" method="get" :action="url" @submit="onSubmit">

        <div class="o-search__info">
            <strong class="o-search__info-title">
                <span>Experience Venice in a day</span><span><span class="icon-bus"></span>&nbsp;<span class="icon-plus-circle cl-prim"></span>&nbsp;<span class="icon-boat-filled"></span></span>
            </strong>
            <div v-if="minDaytripPrice">Standard day return adult ticket from <strong class="cl-prim">{{minDaytripPrice}}</strong></div>
        </div>

        <input type="hidden" name="action" value="start" />
        <input type="hidden" name="ticket" :value="'daytrip'+(differentReturn ? '_multicity' : '')" />
        <div class="o-search__fields" ref="fields">
            <route-selector
                prefix="out_"
                :invertable="false"
                :origin="outOrigin"
                :destination="outDestination"
                :allowedOrigins="allowedOutOrigins"
                @update:origin="outOrigin = $event"
            ></route-selector>

            <div class="is-single" v-if="!differentReturn">
                <datepicker
                    :availableDates="availableDates"
                    ref="datepicker"
                    required
                    name="out_date"
                    title="Select a date"
                    placeholder="Date"
                    icon="date"
                    v-model="date"
                    :minDate="minDate.format('DD/MM/YYYY')"
                    @show="scrollToTop"
                ></datepicker>
            </div>

            <passengers-count ref="passengers" v-model="passengers" v-if="!differentReturn"></passengers-count>

            <div v-if="!differentReturn">
                <button class="btn btn-primary w-100" type="submit">Search</button>
            </div>
        </div>

        <div class="o-search__fields" v-if="differentReturn">
            <route-selector
                prefix="ret_"
                :invertable="false"
                :origin="returnOrigin"
                :destination="returnDestination"
                :allowedOrigins="allowedReturnOrigins"
                @update:destination="returnDestination = $event"
            ></route-selector>

            <div class="is-single">
                <datepicker
                    :availableDates="availableDates"
                    ref="datepicker"
                    required
                    name="out_date"
                    title="Select a date"
                    placeholder="Date"
                    icon="date"
                    v-model="date"
                    :minDate="minDate.format('DD/MM/YYYY')"
                    @show="scrollToTop"
                ></datepicker>
            </div>

            <passengers-count ref="passengers" v-model="passengers"></passengers-count>

            <div>
                <button class="btn btn-primary w-100" type="submit">Search</button>
            </div>
        </div>

        <div class="mt-4 d-flex align-items-center">
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" v-model="differentReturn">
                <label class="custom-control-label" @click="differentReturn = !differentReturn">Different return details?</label>
            </div>
        </div>
    </form>
</template>

<script>
import PassengersCount from '../components/PassengersCount.vue'
import Datepicker from '../components/Datepicker.vue'
import RouteSelector from '../components/RouteSelector.vue'
import { mapState } from 'vuex'
export default ({
    props: [
        'minDaytripPrice',
    ],
    components: {
        PassengersCount,
        RouteSelector,
        Datepicker,
    },
    data() {
        return {
            outOrigin: '',
            outDestination: '',
            returnOrigin: '',
            returnDestination: '',
            differentReturn: this.multicity,
            date: '',
            returnDate: '',
            passengers: {
                adl: 0,
                chd: 0,
                inf: 0,
            },
            url: window.venezialines.booking_page,
            allowedOutOrigins: [],
            allowedReturnOrigins: [],
            availableDates: [],
            cancelSource: null,
        }
    },
    computed: {
        ...mapState([
            'ports',
        ]),
        minDate() {
            return moment()
        },
    },
    watch: {
        outOrigin() {
            console.log("out changed "+this.outOrigin)
            this.getAvailableDates()
        },
        returnDestination() {

            this.getAvailableDates()
        }
    },
    mounted() {
        let venice = this.ports.find(port => port.un_locode == 'ITVCE')
        this.allowedOutOrigins = venice.destinations.map(port => parseInt(port))
        this.allowedReturnOrigins = [venice.id]

        this.outDestination = this.returnOrigin = venice.id.toString()

        const params = new URLSearchParams(window.location.search)

        this.$nextTick(() => {
            this.outOrigin = params.get('out_origin') != venice.id ? params.get('out_origin') : ''
            this.returnDestination = params.get('ret_destination') != venice.id ? params.get('out_destination') : ''
            this.date = params.get('out_date') || ''
            this.passengers.adl = params.get('pax_adl') ? parseInt(params.get('pax_adl')) : 0
            this.passengers.chd = params.get('pax_chd') ? parseInt(params.get('pax_chd')) : 0
            this.passengers.inf = params.get('pax_inf') ? parseInt(params.get('pax_inf')) : 0
            if (params.get('ticket')) {
                this.differentReturn = params.get('ticket').includes('multicity')
            }
        })
    },
    methods: {
        getAvailableDates() {
            if (this.cancelSource) {
                this.cancelSource.cancel()
            }

            if (!this.outOrigin) {
                return Promise.resolve()
            }

            this.cancelSource = axios.CancelToken.source();

            axios.get(window.venezialines.ajaxurl, {
                params: {
                    action: 'get_schedule',
                    origin_id: this.outOrigin,
                    destination_id: this.outDestination,
                    date_from: moment().format('YYYY-MM-DD'),
                    date_to: moment().add(1, 'year').endOf('year').format('YYYY-MM-DD'),
                },
                cancelToken: this.cancelSource.token,
            }).then(response => {
                this.availableDates = response.data.map(trip => moment(trip.departure).format('YYYY-MM-DD'))
                this.cancelSource = null
            }).catch(err => {})
        },
        onSubmit(e) {
            let valid = true
            if (!this.date) {
                this.$refs.datepicker.show()
                valid = false
            }
            else if (this.passengers.adl < 1) {
                this.$refs.passengers.toggle()
                valid = false
            }
            valid || e.preventDefault()
        },
        scrollToTop() {
            this.$scrollTo(this.$refs.fields, { offset: -20 })
        }
    }
})
</script>